// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.library_library-wrapper_xJvV5 {
    display: flex;
    height: calc(100% - 3.125rem);
}

.library_library-scroll-grid_GaYe9 {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: stretch;
    background: var(--ui-secondary);
    flex-wrap: wrap;
    overflow-y: auto;
    padding: 0.5rem;
}

.library_filter-bar_WXJzs {
    display: flex;
    justify-content: flex-start;
    background-color: var(--looks-transparent);
    font-size: .875rem;
}

.library_filter-bar-content_kYLrN {
    display: flex;
    flex-direction: column;
    gap: .75rem;
    width: 20rem;
    padding: 1rem;
}

.library_arrow-icon-wrapper_WENhf {
    align-self: center;
    padding: 0.5rem;
    cursor: pointer;
}

.library_arrow-icon_nH5iO {
    width: 1rem;
    height: 1.6rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

[dir="rtl"] .library_arrow-icon_nH5iO:not(.library_is-opened_g9gUZ),
[dir="ltr"] .library_arrow-icon_nH5iO.library_is-opened_g9gUZ {
    transform: scaleX(-1);
}

.library_filter_QJgGj {
    flex-grow: 0;
}

.library_divider_vJM4Z {
    border-bottom: 1px dashed var(--ui-black-transparent);
    transform: scaleX(1.05);
}

.library_tag-wrapper_z68dH {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: .75rem;
}

.library_spinner-wrapper_OXCzr {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.library_tw-gallery-mirror-note_EzgVO {
    opacity: 0.75;
    flex-basis: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/library.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.library-wrapper {\n    display: flex;\n    height: calc(100% - 3.125rem);\n}\n\n.library-scroll-grid {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: stretch;\n    background: var(--ui-secondary);\n    flex-wrap: wrap;\n    overflow-y: auto;\n    padding: 0.5rem;\n}\n\n.filter-bar {\n    display: flex;\n    justify-content: flex-start;\n    background-color: var(--looks-transparent);\n    font-size: .875rem;\n}\n\n.filter-bar-content {\n    display: flex;\n    flex-direction: column;\n    gap: .75rem;\n    width: 20rem;\n    padding: 1rem;\n}\n\n.arrow-icon-wrapper {\n    align-self: center;\n    padding: 0.5rem;\n    cursor: pointer;\n}\n\n.arrow-icon {\n    width: 1rem;\n    height: 1.6rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n[dir=\"rtl\"] .arrow-icon:not(.is-opened),\n[dir=\"ltr\"] .arrow-icon.is-opened {\n    transform: scaleX(-1);\n}\n\n.filter {\n    flex-grow: 0;\n}\n\n.divider {\n    border-bottom: 1px dashed var(--ui-black-transparent);\n    transform: scaleX(1.05);\n}\n\n.tag-wrapper {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: .75rem;\n}\n\n.spinner-wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tw-gallery-mirror-note {\n    opacity: 0.75;\n    flex-basis: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `library_library-wrapper_xJvV5`;
export { _1 as "library-wrapper" };
export var libraryWrapper = `library_library-wrapper_xJvV5`;
var _2 = `library_library-scroll-grid_GaYe9`;
export { _2 as "library-scroll-grid" };
export var libraryScrollGrid = `library_library-scroll-grid_GaYe9`;
var _3 = `library_filter-bar_WXJzs`;
export { _3 as "filter-bar" };
export var filterBar = `library_filter-bar_WXJzs`;
var _4 = `library_filter-bar-content_kYLrN`;
export { _4 as "filter-bar-content" };
export var filterBarContent = `library_filter-bar-content_kYLrN`;
var _5 = `library_arrow-icon-wrapper_WENhf`;
export { _5 as "arrow-icon-wrapper" };
export var arrowIconWrapper = `library_arrow-icon-wrapper_WENhf`;
var _6 = `library_arrow-icon_nH5iO`;
export { _6 as "arrow-icon" };
export var arrowIcon = `library_arrow-icon_nH5iO`;
var _7 = `library_is-opened_g9gUZ`;
export { _7 as "is-opened" };
export var isOpened = `library_is-opened_g9gUZ`;
export var filter = `library_filter_QJgGj`;
export var divider = `library_divider_vJM4Z`;
var _8 = `library_tag-wrapper_z68dH`;
export { _8 as "tag-wrapper" };
export var tagWrapper = `library_tag-wrapper_z68dH`;
var _9 = `library_spinner-wrapper_OXCzr`;
export { _9 as "spinner-wrapper" };
export var spinnerWrapper = `library_spinner-wrapper_OXCzr`;
var _a = `library_tw-gallery-mirror-note_EzgVO`;
export { _a as "tw-gallery-mirror-note" };
export var twGalleryMirrorNote = `library_tw-gallery-mirror-note_EzgVO`;
export default ___CSS_LOADER_EXPORT___;
